var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70999 0.411133H2.45825C1.29916 0.411133 0.360352 1.49368 0.360352 2.83024V8.03132C0.360352 9.36787 1.29916 10.4504 2.45825 10.4504H8.01767C9.17676 10.4504 10.1156 9.36787 10.1156 8.03132V5.12839",
    stroke: "url(#paint0_linear_2552_634)",
    strokeWidth: 0.720721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12988 5.52272L10.1274 0.360352",
    stroke: "url(#paint1_linear_2552_634)",
    strokeWidth: 0.720721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33691 0.360352H10.1277V3.17619",
    stroke: "url(#paint2_linear_2552_634)",
    strokeWidth: 0.720721,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2552_634",
    x1: 0.360352,
    y1: -0.556509,
    x2: 12.62,
    y2: 8.95077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#725DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F76FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2552_634",
    x1: -0.186586,
    y1: 1.01938,
    x2: 11.1894,
    y2: 10.8672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#725DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F76FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2552_634",
    x1: 0.459584,
    y1: 0.963746,
    x2: 10.9076,
    y2: 10.2236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#725DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F76FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoto);
export default __webpack_public_path__ + "static/media/goto.6bad5be4a0aae534e0d3bf2dbf6f299f.svg";
export { ForwardRef as ReactComponent };